var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.member)?_c('div',_vm._l((_vm.member),function(l,index){return _c('small',{key:index,staticClass:"form-text text-danger"},[_vm._v(_vm._s(l))])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }